import { HttpClient } from '@angular/common/http';
import { map, tap, of } from 'rxjs';
import { Injectable } from '@angular/core';

import { SuggestiveListFilter, DropdownFilter } from '../../../models/datacenter-filters';
import { AdditionalInput } from '../../../models/datacenter-aggrid-view';
import { padSoldto } from '../../../utils/padding';

@Injectable({ providedIn: 'any' })
export class ProductListFilterApiService {
	datacenterFilter: SuggestiveListFilter | DropdownFilter | undefined;

	private readonly cache = new Map<string, { code?: string | undefined; translation: string }[]>();

	constructor(
		private readonly http: HttpClient
	) {}

	getItemBySearchTextAndAdditionalInput(additionalInput: AdditionalInput, searchText?: string) {
		if (!this.datacenterFilter) {
			return of([]);
		}
		return this.sendProductFieldRequest(additionalInput, searchText);
	}

	private sendProductFieldRequest(additionalInput?: AdditionalInput, searchText?: string) {
		if (!this.datacenterFilter) {
			return of([]);
		}
		const { requestApi, apiNameCode, apiNameTranslation } = this.datacenterFilter;
		const url = new URL(`${ requestApi.url }/${ apiNameCode || apiNameTranslation }`);
		const params = url.searchParams;

		if (searchText) {
			params.append('searchText', searchText);
		}

		if (additionalInput?.['soldTo'] && additionalInput['subCategory'] && additionalInput['form']) {
			params.append('soldTo', padSoldto(String(additionalInput['soldTo'])));
			params.append('subCategory', additionalInput['subCategory']);
			params.append('form', additionalInput['form']);
		}

		const cacheResult = this.cache.get(url.toString());
		if (cacheResult) {
			return of(cacheResult);
		}

		return this.http.get<Record<string, string>[]>(url.toString())
			.pipe(
				map(
					values => values.map(value => ({
						code: String(value['code']),
						translation: String(value['value'])
					}))
				),
				tap(result => {
					this.cache.set(url.toString(), result);
				})
			);
	}
}
